import React, { useState } from "react";
import { FieldButtonGroup } from "../../components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faCheck,
  faAngleDown,
} from "@fortawesome/pro-light-svg-icons";

const TaskManagementData = {
  Payroll: [
    {
      status: 1,
      label: "4 Files with error",
      subLabel: "error correction",
    },
    {
      status: 2,
      label: "August payroll file due",
      subLabel: "Payroll upload",
    },
  ],
  Requests: [
    {
      status: 1,
      label: "6 loans waiting for approval",
      subLabel: "Loans",
    },
    {
      status: 0,
      label: "3 withdrawal requests",
      subLabel: "Withdrawals",
    },
    {
      status: 0,
      label: "6 loans waiting for approval",
      subLabel: "Loans",
    },
    {
      status: 1,
      label: "3 withdrawal requests",
      subLabel: "Withdrawals",
    },
  ],
};

const NotificationData = [
  {
    dateTime: "Yesterday at 11:42 PM",
    content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit,",
  },
  {
    dateTime: "Yesterday at 11:42 PM",
    content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit,",
  },
  {
    dateTime: "Yesterday at 11:42 PM",
    content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit,",
  },
];

const NotificationCard = ({
  displayImage,
  dateTime = "date goes here",
  content = "Lorem ipsum dolor sit amet, consectetur adipiscing elit,",
}) => {
  return (
    <div className="d-flex border-bottom py-3">
      <div
        style={{ borderRadius: "50%", padding: "10px", fontSize: "20px" }}
        className="profpic mr-2"
      >
        DH
      </div>

      <div>
        <div>{content}</div>
        <div className="mt-3" style={{ color: "grey" }}>
          {dateTime}
        </div>
      </div>
    </div>
  );
};

const FilterComponent = ({
  request,
  setRequest,
  setResponse,
  filterValue,
  setFilterValue,
}) => {
  const values = [
    {
      label: "High",
      value: 2,
      color: "rgba(235, 78, 61, 1)",
    },
    {
      label: "Medium",
      value: 1,
      color: "rgba(241, 153, 55, 1)",
    },
    {
      label: "Low",
      value: 0,
      color: "rgba(28, 126, 24, 1)",
    },
  ];

  return (
    <div className="d-flex flex-row justify-content-start">
      <form name="myform" className="form">
        <div className={`optionsDivNewLayout`} style={{ width: "100%" }}>
          {values.map((filterName, index) => (
            <>
              <input
                type="radio"
                id={index}
                className={`optionBtn-${filterName.label}`}
                name={"radioButton"}
                value={index}
                checked={filterValue == index}
                onChange={(e) => {
                  setFilterValue(index);
                }}
              />
              <label
                style={{ color: filterName.color }}
                className={`optionLabel-${filterName.label}`}
                for={index}
              >
                {filterName.label}
              </label>
            </>
          ))}
        </div>{" "}
      </form>
    </div>
  );
};

function TaskManagementNotificationComponent(props) {
  const [filterValue, setFilterValue] = useState(null);
  const TaskManagementCount = 12;
  const NotificationsCount = 3;

  const optionsForFieldButtons = [
    {
      label: `Task management - ${TaskManagementCount}`,
      value: 0,
    },
    {
      label: `Notifications - ${NotificationsCount}`,
      value: 1,
    },
  ];

  const [radioButtonSelected, setRadioButtonSelected] = useState(0);
  const TaskManagementCard = ({ status, label, subLabel }) => {
    return (
      <div
        style={{
          background: "#FBFBFD",
          border: "0.5px solid #F2F2F2",
          borderLeft: `3px solid ${
            status === 2 ? "#EB4E3D" : status === 1 ? "#F19937" : "#1C7E18"
          }`,
          borderRadius: "5px",
          boxShadow: "0px 0px 1px rgba(0, 0, 0, 0.1)",
          height: "60px",
          display: "flex",
          alignItems: "center",
          height: "100%",
        }}
      >
        <div className="ml-3">
          <div style={{ fontWeight: "400", fontSize: "14px" }}>{label}</div>
          <div
            style={{ color: "#828282", fontSize: "12px", fontWeight: "500" }}
          >
            {subLabel}
          </div>
        </div>
        <div className="ml-auto mr-3">
          <FontAwesomeIcon icon={faArrowRight} />
        </div>
      </div>
    );
  };

  return (
    <div
      style={{
        background: "white",
        width: "100%",
        borderRadius: "10px",
        boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.1)",
        padding: "20px",
        height: "100%",
      }}
    >
      <FieldButtonGroup
        isRequired
        size="lg"
        style={{ width: "100%" }}
        options={optionsForFieldButtons}
        selectedValue={radioButtonSelected}
        onChange={(value) => {
          setRadioButtonSelected(value);
        }}
      />
      {radioButtonSelected === 0 ? (
        <>
          <FilterComponent
            filterValue={filterValue}
            setFilterValue={setFilterValue}
          />
          {Object.keys(TaskManagementData).map((key) => {
            const data = TaskManagementData[key];
            return (
              <>
                <div style={{ fontWeight: "500", fontSize: "14px" }}>{key}</div>
                <div>
                  {data.map((_) => {
                    return (
                      <div className="my-2">
                        <TaskManagementCard {..._} />
                      </div>
                    );
                  })}
                </div>
              </>
            );
          })}
        </>
      ) : (
        <>
          <div className="d-flex border-bottom pb-2">
            <div>
              Showing all{" "}
              <span className="ml-2">
                <FontAwesomeIcon icon={faAngleDown} />
              </span>
            </div>
            <div style={{ color: "blue" }} className="ml-auto">
              Mark all as read{" "}
              <span className="ml-2">
                <FontAwesomeIcon icon={faCheck} />
              </span>
            </div>
          </div>
          {NotificationData.map((_) => {
            return <NotificationCard {..._} />;
          })}
        </>
      )}
    </div>
  );
}

export default TaskManagementNotificationComponent;
